module.exports = __webpack_public_path__ + "img/italy-respiratory-diseases-male.d26214f6.png";